/* Approximate converted price presentation only. BUCKS DOM text and data attributes remain untouched. */
(() => {
  const TARGET = '.money.buckscc-converted[bucks-current][bucks-currency]';
  let queued = false;
  const fmt = (raw, currency) => {
    if (!raw || currency === 'USD') return null;
    const number = raw.match(/[0-9][0-9.,\s\u00a0]*/);
    if (!number) return null;
    let n = number[0].trim(), lastDot = n.lastIndexOf('.'), lastComma = n.lastIndexOf(',');
    let idx = Math.max(lastDot,lastComma), decimal = idx >= 0 && /^\d{1,2}$/.test(n.slice(idx+1));
    const sep = decimal ? n[idx] : null;
    let integer = (decimal?n.slice(0,idx):n).replace(/\D/g,'');
    let fraction = decimal?n.slice(idx+1):'';
    if (!integer) return null;
    const value = Number(integer+(fraction?'.'+fraction:''));
    if (!Number.isFinite(value)) return null;
    const rounded = Math.ceil(value / 5) * 5;
    const beforeDecimals = decimal ? n.slice(0,idx) : n;
    const thousands = beforeDecimals.includes(',') ? ',' :
      beforeDecimals.includes('.') ? '.' :
      (sep === ',' ? '.' : ',');
    const formatted = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g,thousands);
    const whitespace = number[0].match(/\s*$/)?.[0] || '';
    return raw.replace(number[0],formatted + whitespace);
  };
  function update() {
    queued = false;
    document.querySelectorAll(TARGET).forEach(el => {
      const currency = el.getAttribute('bucks-currency');
      const exact = el.getAttribute('bucks-current');
      const result = fmt(exact,currency);
      if (!result || !currency || currency === 'USD') {
        el.classList.remove('en-price-visual-rounded');
        el.removeAttribute('data-en-rounded');
        return;
      }
      if (el.getAttribute('data-en-rounded') !== result) el.setAttribute('data-en-rounded', result);
      if (!el.classList.contains('en-price-visual-rounded')) {
        const size = getComputedStyle(el).fontSize;
        el.style.setProperty('--en-visual-money-size',size);
        el.classList.add('en-price-visual-rounded');
      }
    });
  }
  function schedule() {
    if (queued) return;
    queued=true;
    requestAnimationFrame(update);
  }
  const observer = new MutationObserver(schedule);
  function start() {
    observer.observe(document.body,{
      subtree:true,childList:true,characterData:true,
      attributes:true,attributeFilter:['bucks-current','bucks-currency']
    });
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  window.addEventListener('pageshow',schedule);
  document.addEventListener('shopify:section:load',schedule);
})();
